'use client';

import { COLORS } from '@/constants';
import { HouseKeyIcon, PriceWalletIcon } from '@/components';
import { useTranslations } from 'next-intl';
import { FC } from 'react';
import { useGetBrokerOfficeDetailsBySlug } from '@/queris';
import { formatOfficePriceRange } from '../utils';
import {
  PriceCard,
  PriceCardHeader,
  PriceIconBox,
  PriceLabel,
  PriceValue,
  PricesGrid,
  Section,
  SectionTitle,
} from '../styled';

type BrokerProfilePricesProps = {
  directLink?: string;
};

export const BrokerProfilePrices: FC<BrokerProfilePricesProps> = ({ directLink }) => {
  const t = useTranslations('memberProfile');
  const { data, isLoading } = useGetBrokerOfficeDetailsBySlug(directLink);

  const sale = formatOfficePriceRange(data?.statistics?.priceRanges?.sale);
  const rent = formatOfficePriceRange(data?.statistics?.priceRanges?.rent);

  if (!directLink || (!isLoading && !sale && !rent)) return null;

  return (
    <Section>
      <SectionTitle>{t('prices.title')}</SectionTitle>
      <PricesGrid>
        {(isLoading || sale) && (
          <PriceCard>
            <PriceCardHeader>
              <PriceIconBox>
                <PriceWalletIcon width={24} height={24} />
              </PriceIconBox>
              <PriceLabel>{t('prices.buyRange')}</PriceLabel>
            </PriceCardHeader>
            <PriceValue>{sale ?? '—'}</PriceValue>
          </PriceCard>
        )}
        {(isLoading || rent) && (
          <PriceCard>
            <PriceCardHeader>
              <PriceIconBox $bg={COLORS['secondary/500']}>
                <HouseKeyIcon width={24} height={24} fill="white" />
              </PriceIconBox>
              <PriceLabel>{t('prices.rentRange')}</PriceLabel>
            </PriceCardHeader>
            <PriceValue>{rent ?? '—'}</PriceValue>
          </PriceCard>
        )}
      </PricesGrid>
    </Section>
  );
};
